import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'anf-core-react';
import { usePhoneLinkParser } from '../../hooks';

/**
 * PaymentSupportMessage - Displays support message when WSS payment update is not available
 * Automatically converts phone numbers to clickable links for mobile users
 * Matches the existing WSS flow styling for disabled payment update scenarios
 */
function PaymentSupportMessage({ message }) {
  const parseWithLinks = usePhoneLinkParser({ strategy: 'token' });

  if (!message || !message.value) {
    return null;
  }

  const parseMessageWithPhoneLinks = (text) => parseWithLinks(text)
    .map((p, idx) => ({ ...p, key: `${p.type}-${idx}` }));

  const messageElements = parseMessageWithPhoneLinks(message.value);

  return (
    <div className="payment-support-message">
      <div>
        {messageElements.map((element) => (
          element.type === 'text' ? (
            <span key={element.key}>{element.content}</span>
          ) : (
            <Link key={element.key} classList="link-phoneNumber" href={element.href}>
              {element.content}
            </Link>
          )
        ))}
      </div>
    </div>
  );
}

PaymentSupportMessage.propTypes = {
  message: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }),
};

PaymentSupportMessage.defaultProps = {
  message: null,
};

export default PaymentSupportMessage;
